import { render, staticRenderFns } from "./ViewerHeaderDesign.vue?vue&type=template&id=fefa38a2&scoped=true"
import script from "./ViewerHeaderDesign.vue?vue&type=script&lang=js"
export * from "./ViewerHeaderDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefa38a2",
  null
  
)

export default component.exports